import * as React from 'react';

export class ListItemText extends React.PureComponent<{}, {}> {
  public render() {
    return <div style={{ flexGrow: 1 }}>{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/List/ListItemText.tsx